import { apiClient } from '@/lib/apiClient';

export interface UploadTemporalResponse {
  upload_url: string;
  uid_foto: string;
}

export interface PresignedDownloadTemporalResponse {
  presigned_url: string;
  presigned_url_expires_at: string;
  uid_foto: string;
}

export const fotosTemporalesApi = {
  async requestUpload(contentType: string): Promise<UploadTemporalResponse> {
    const response = await apiClient.post<UploadTemporalResponse>('/fotos/upload-temporal', {
      content_type: contentType,
    });
    return response.data;
  },

  async getFotoTemporal(uidFoto: string): Promise<PresignedDownloadTemporalResponse> {
    const response = await apiClient.get<PresignedDownloadTemporalResponse>(
      `/fotos/temporal/${uidFoto}`,
    );
    return response.data;
  },
};
